
    import '/home/ec2-user/Youlify-Design/components/skeleton/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["skeleton-demo-basic","skeleton-demo-complex","skeleton-demo-active","skeleton-demo-element","skeleton-demo-children","skeleton-demo-list","skeleton-demo-componenttoken"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/skeleton/index.zh-CN.md?type=demo')
};